import { SegmentedControlItem } from "@mantine/core";
import { TFunction } from "i18next";

import { TReceiptTypeFilter } from "@prostocheck/shared";

import { RECEIPT_TYPE_FILTERS } from "./cash-register.constants";

export const toReceiptTypeOptions = (
  t: TFunction,
): SegmentedControlItem<TReceiptTypeFilter>[] =>
  RECEIPT_TYPE_FILTERS.map(({ value, namespace, labelKey }) => ({
    value,
    label: t(`${namespace}:${labelKey}`),
  }));
